import { Component, Inject, OnInit, Optional, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFileExcel } from '@fortawesome/free-solid-svg-icons';
import { SelectionModel } from '@angular/cdk/collections';

// Material Imports
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MaterialModule } from '../material.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTableExporterModule } from 'mat-table-exporter';
import { ToastrService } from 'ngx-toastr';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatDatepicker } from '@angular/material/datepicker';
import { MatPaginator, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AbsenceUpdateComponent } from './update/absenceupdate.component';
import { AbsenceDeleteComponent } from './delete/absencedelete.component';
import { Absence } from '../_model/Absence';
import { AbsenceService } from '../_services/absence.service';
import { environment } from '../../environments/environment';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { AuthenticationService } from '../_services/authentication.service';
import { User } from '../_model/user';
import { AbsenceapproveComponent } from './absenceapprove/absenceapprove.component';
import { AbsencerejectComponent } from './absencereject/absencereject.component';
import moment from 'moment';
// tslint:disable-next-line:no-duplicate-imports
import { EventService } from '../_services/event.service';
import { LookupService } from '../_services/lookup.service';
import { UtilityService } from '../_helpers/utility.service';
import { AbsencedetailComponent } from './detail/absencedetail.component';
import { RejectselectedComponent } from './rejectselected/rejectselected.component';
import { ApproveselectedComponent } from './approveselected/approveselected.component';
import { BaseComponent } from '../common/base-component';
import { AbsenceSearchRequest } from '../_model/request/AbsenceSearchRequest';
import { CustomDatePipe } from '../_pipe/custom-date.pipe';
import { AbsenceReportRequest } from '../_model/request/AbsenceReportRequest';
import { ReportService } from '../_services/report.service';
import { AppConstants } from '../_utils/constants';

const MY_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-absence',
    templateUrl: './absence.component.html', 
    styleUrls: ['./absence.component.sass'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatTabsModule,
        MatSelectModule,
        MatIconModule,
        MatCheckboxModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatDialogModule,
        MatTableExporterModule,
        MaterialModule
    ],
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ]
})
export class AbsenceComponent extends BaseComponent implements OnInit {
    @ViewChild('myRequestPaginator', { static: false }) myRequestPaginator: MatPaginator;
    @ViewChild('myApprovalsPaginator', { static: false }) myApprovalsPaginator: MatPaginator;
    @ViewChild('rejectsPaginator', { static: false }) rejectsPaginator: MatPaginator;
    @ViewChild('waitingsPaginator', { static: false }) waitingsPaginator: MatPaginator;
    @ViewChild('allPaginator', { static: false }) allPaginator: MatPaginator;
    pageSizeOptions: number[] = [5, 10, 25, 100];
    pageEvent: PageEvent;

    // sort objects
    @ViewChild('WaitingSort', { static: false }) waitingSort: MatSort;
    @ViewChild('ApprovalSort', { static: false }) approvalSort: MatSort;
    @ViewChild('RejectSort', { static: false }) rejectSort: MatSort;
    @ViewChild('MyRequestSort', { static: false }) myRequestSort: MatSort;
    @ViewChild('AllSort', { static: false }) allSort: MatSort;

    displayedColumns: string[] = ['isCompleted', 'name', 'departmentName', 'absenceTypeName', 'absenceDay', 'freeDayAmount', 'absenceStartDate', 'absenceEndDate', 'description', 'actions'];
    displayedColumnsWaiting: string[] = ['select', 'name', 'departmentName', 'absenceTypeName', 'absenceDay', 'freeDayAmount', 'absenceStartDate', 'absenceEndDate', 'description', 'actions'];

    // Datasources
    dataSource: MatTableDataSource<any>;
    dsMyRequest: MatTableDataSource<any>;
    dsMyApprovals: MatTableDataSource<any>;
    dsRejects: MatTableDataSource<any>;
    dsWaitings: MatTableDataSource<any>;
    dsAll: MatTableDataSource<any>;
    filterValue = null;
    selectedTab = 0;
    currentUser: User;
    absenceList: Absence[];
    selectedAbsence: Absence;
    fileUploadRoot = environment.fileUploadPath;
    selection = new SelectionModel<Absence>(true, []);

    // filter values
    startDateFilterValue1: any = new FormControl(); // new FormControl(moment());
    endDateFilterValue1: any = new FormControl();
    startDateFilterValue2: any = new FormControl();
    endDateFilterValue2: any = new FormControl();
    startDateFilterValue3: any = new FormControl();
    endDateFilterValue3: any = new FormControl();
    startDateFilterValue4: any = new FormControl();
    endDateFilterValue4: any = new FormControl();
    startDateFilterValue5: any = new FormControl();
    endDateFilterValue5: any = new FormControl();
    absenceTypeList: any[] = [{ id: null, description: 'Hepsi' }];
    selectedAbsenceType1: any = this.absenceTypeList[0];
    selectedAbsenceType2: any = this.absenceTypeList[0];
    selectedAbsenceType3: any = this.absenceTypeList[0];
    selectedAbsenceType4: any = this.absenceTypeList[0];
    selectedAbsenceType5: any = this.absenceTypeList[0];
    departmentList: any[] = [{ description: 'Hepsi' }];
    StatuList: any[] = [{ description: 'Hepsi' },{id: 0 , description: 'Bekliyor'}, {id: 1 , description: 'Onaylandı' }, { id:-1 ,description: 'Reddedildi' }];
    selectedDepartment1: any = this.departmentList[0];
    selectedDepartment2: any = this.departmentList[0];
    selectedDepartment3: any = this.departmentList[0];
    selectedDepartment4: any = this.departmentList[0];
    selectedDepartment5: any = this.departmentList[0];
    selectedStatu5: any = this.StatuList[0];
    date = new FormControl(moment());
    searchFullName1 = '';
    searchFullName2 = '';
    searchFullName3 = '';
    searchFullName4 = '';
    searchFullName5 = '';

    size = 20;
    pageNumber = 0;
    absenceSearchRequest: AbsenceSearchRequest = new AbsenceSearchRequest(this.pageNumber, this.size, null, null);

    // fontawesome icon
    fileExcelIcon = faFileExcel;

    // pagination parameters
    paginatorIntl = new MatPaginatorIntl();

    constructor(private absenceService: AbsenceService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: Absence[],
        private toastr: ToastrService,
        public dialog: MatDialog,
        public authService: AuthenticationService,
        public eventService: EventService,
        private lookupService: LookupService,
        private utilityService: UtilityService,
        private reportService: ReportService) {
        super();
        this.currentUser = authService.currentUserValue;
        this.paginatorIntl.itemsPerPageLabel = 'Satır sayısı';
        this.paginatorIntl.getRangeLabel = function (page, pageSize, length) {
            if (length === 0 || pageSize === 0) {
                return 'Kayıt bulunamadı';
            }
            length = Math.max(length, 0);
            const startIndex = page * pageSize;
            // If the start index exceeds the list length, do not try and fix the end index to the end.
            const endIndex = startIndex < length ?
                Math.min(startIndex + pageSize, length) :
                startIndex + pageSize;
            return length + ' Kayıttan ' + (startIndex + 1) + ' - ' + endIndex + ' arası ';
        };
    }

    ngOnInit() {
        this.selection = new SelectionModel<Absence>(true, []);

        this.getWaitingData();
        this.getMyRequestData();
        this.getApprovalData();
        this.getRejectData();
        this.getAllData();
        this.currentUser = this.authService.currentUserValue;

        this.departmentList.push(...this.lookupService.localListByLookupCode('DEPARTMENT').filter(dept => dept.parentLookup || dept.parentLookup !== null).sort((a, b) =>
            a.lookupValue.toLowerCase().localeCompare(b.lookupValue.toLowerCase(), 'tr')
        ));
        // this.absenceTypeList1.push(...this.lookupService.localListByLookupCode('ABSENCE_TYPE'));
        this.absenceTypeList.push(...this.lookupService.localListByLookupCode('ABSENCE_TYPE')
            //.map(z => ({ description: z.description }))
            .sort((a, b) =>
                a.description.toLowerCase().localeCompare(b.description.toLowerCase(), 'tr')
            ));
    }

    pageEventOfAll(pageEvent: PageEvent) {
        this.absenceSearchRequest.size = pageEvent.pageSize;
        this.absenceSearchRequest.pageNumber = pageEvent.pageIndex;
        this.getAllData();

    }

    pageEventOfWaitings(pageEvent: PageEvent) {
        this.absenceSearchRequest.size = pageEvent.pageSize;
        this.absenceSearchRequest.pageNumber = pageEvent.pageIndex;
        this.getWaitingData();
    }

    pageEventOfMyRequests(pageEvent: PageEvent) {
        this.absenceSearchRequest.size = pageEvent.pageSize;
        this.absenceSearchRequest.pageNumber = pageEvent.pageIndex;
        this.getMyRequestData();
    }

    pageEventOfApprovals(pageEvent: PageEvent) {
        this.absenceSearchRequest.size = pageEvent.pageSize;
        this.absenceSearchRequest.pageNumber = pageEvent.pageIndex;
        this.getApprovalData();
    }

    pageEventOfRejects(pageEvent: PageEvent) {
        this.absenceSearchRequest.size = pageEvent.pageSize;
        this.absenceSearchRequest.pageNumber = pageEvent.pageIndex;
        this.getRejectData();
    }

    sortChangeOfWaitings($event) {
        const sortId = $event.active;
        const sortDirection = $event.direction;
        this.absenceSearchRequest.sortColumn = sortId;
        this.absenceSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
        this.absenceSearchRequest.pageNumber = this.waitingsPaginator.pageIndex;
        this.getWaitingData();
    }

    sortChangeOfMyRequest($event) {
        const sortId = $event.active;
        const sortDirection = $event.direction;
        this.absenceSearchRequest.sortColumn = sortId;
        this.absenceSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
        this.absenceSearchRequest.pageNumber = this.myRequestPaginator.pageIndex;
        this.getMyRequestData();
    }

    sortChangeOfApprovals($event) {
        const sortId = $event.active;
        const sortDirection = $event.direction;
        this.absenceSearchRequest.sortColumn = sortId;
        this.absenceSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
        this.absenceSearchRequest.pageNumber = this.myApprovalsPaginator.pageIndex;
        this.getApprovalData();
    }

    sortChangeOfRejects($event) {
        const sortId = $event.active;
        const sortDirection = $event.direction;
        this.absenceSearchRequest.sortColumn = sortId;
        this.absenceSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
        this.absenceSearchRequest.pageNumber = this.rejectsPaginator.pageIndex;
        this.getRejectData();
    }

    sortChangeOfAll($event) {
        const sortId = $event.active;
        const sortDirection = $event.direction;
        this.absenceSearchRequest.sortColumn = sortId;
        this.absenceSearchRequest.sortDirection = sortDirection === 'asc' ? 1 : 0;
        this.absenceSearchRequest.pageNumber = this.allPaginator.pageIndex;
        this.getAllData();
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dsWaitings.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected() ?
            this.selection.clear() :
            this.dsWaitings.data.forEach(row => this.selection.select(row));
    }
    /**
     * tabNo= absenceComponentte bulunan sekmelerin sira numarasi
     * simdilik boyle bir ayrim ile islemlerimizi gerceklestiriyoruz
     */
    openUpdateModal(absence: Absence, tabNo: number) {

        absence.tabNo = tabNo;
        absence.isNew = false;
        this.selectedAbsence = absence;
        const dialogRef = this.dialog.open(AbsenceUpdateComponent, {
            width: '650px',
            height: 'auto',
            data: absence

        });
        this.dsMyRequest.filter = null;
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                if (tabNo === 1) {
                    const absenceIndex = this.dsWaitings.data.findIndex(abs => abs.id === result.data.id);
                    this.dsWaitings.data.splice(absenceIndex, 1, result.data);
                    this.dsWaitings._updateChangeSubscription();
                } else if (tabNo === 2) {
                    const absenceIndex = this.dsMyRequest.data.findIndex(abs => abs.id === result.data.id);
                    this.dsMyRequest.data.splice(absenceIndex, 1, result.data);
                    this.dsMyRequest._updateChangeSubscription();
                } else if (tabNo === 5) {
                    const absenceIndex = this.dsAll.data.findIndex(abs => abs.id === result.data.id);
                    this.dsAll.data.splice(absenceIndex, 1, result.data);
                    this.dsAll._updateChangeSubscription();
                }
            }
            // tabloda ilgili satiri bul ve yer degistir
            if (this.filterValue != null) {
                this.dsMyRequest.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
            }
        });
    }

    openDeleteModal(absence: Absence) {
        this.selectedAbsence = absence;
        const dialogRef = this.dialog.open(AbsenceDeleteComponent, {
            width: '300px',
            data: absence
        });

        dialogRef.afterClosed().subscribe(result => {
            const absenceIndex = this.dsMyRequest.data.findIndex(abs => abs.id === result.data);
            this.dsMyRequest.data.splice(absenceIndex, 1);
            this.dsMyRequest._updateChangeSubscription();
        });
    }

    openApproveModal(absence: Absence) {
        this.selectedAbsence = absence;

        const dialogRef = this.dialog.open(AbsenceapproveComponent, {
            width: '400px',
            minHeight: '80px',
            data: absence
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                const absenceIndex = this.dsWaitings.data.findIndex(abs => abs.id === absence.id);
                this.dsWaitings.data.splice(absenceIndex, 1);
                this.dsWaitings._updateChangeSubscription();
            }
        });
    }

    openApproveSelectedModal() {
        const dialogRef = this.dialog.open(ApproveselectedComponent, {
            width: '300px',
            data: this.selection.selected
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }

    openRejectSelectedModal() {

        const dialogRef = this.dialog.open(RejectselectedComponent, {
            width: '300px',
            data: this.selection.selected
        });

        dialogRef.afterClosed().subscribe(result => {
            this.ngOnInit();
        });
    }
    openRejectModal(absence: Absence) {
        this.selectedAbsence = absence;

        const dialogRef = this.dialog.open(AbsencerejectComponent, {
            width: '400px',
            data: absence
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result === true) {
                const absenceIndex = this.dsWaitings.data.findIndex(abs => abs.id === absence.id);
                this.dsWaitings.data.splice(absenceIndex, 1);
                this.dsWaitings._updateChangeSubscription();
            }
        });
    }

    openAbsenceCreateModal(isNew: boolean, absence?: Absence) {

        let modalData = new Absence();
        if (absence != null) {
            absence.isNew = isNew;
            modalData = absence;
        } else {
            modalData.isNew = isNew;
        }
        const dialogRef = this.dialog.open(AbsenceUpdateComponent, {
            width: '650px',
            height: 'auto',
            data: modalData
        });

        // this.dsMyRequest.filter = null;
        dialogRef.afterClosed().subscribe(result => {
            if (result) {

                this.dsMyRequest.data.unshift(result.data);
                this.dsMyRequest._updateChangeSubscription();
            }
            // tabloda ilgili satiri bul ve yer degistir
            if (this.filterValue != null) {
                this.dsMyRequest.filter = this.utilityService.toTurkishLowerCase(this.filterValue.trim());
            }
        });
    }

    openDetail(row) {

        const dialogRef = this.dialog.open(AbsencedetailComponent, {
            width: '550px',
            height: 'auto',
            data: row
        });

        dialogRef.afterClosed();
    }

    filterGrid(tabNo: number, pageStatus: string) {

        this.absenceSearchRequest.pageNumber = 0;
        // change datasource by using filters
        if (tabNo === 0) { // onay bekleyen
            //this.dsWaitings.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue1.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue1.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;

            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType1.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment1.id;
            this.absenceSearchRequest.fullName = this.searchFullName1;
            this.getWaitingData();
        } else if (tabNo === 1) { // izinlerim
            //this.dsMyRequest.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue2.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue2.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;

            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType2.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment2.id;
            this.absenceSearchRequest.fullName = this.searchFullName2;
            this.getMyRequestData();
        } else if (tabNo === 2) { // onayladiklarim
            //this.dsMyApprovals.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue3.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue3.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;

            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType3.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment3.id;
            this.absenceSearchRequest.fullName = this.searchFullName3;
            this.getApprovalData();
        } else if (tabNo === 3) { // reddediklerim
            //this.dsRejects.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue4.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue4.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;

            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType4.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment4.id;
            this.absenceSearchRequest.fullName = this.searchFullName4;
            this.getRejectData();
        } else if (tabNo === 4) { // tum izinler
            //this.dsAll.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue5.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue5.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.status = this.selectedStatu5.id;
            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType5.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment5.id;
            this.absenceSearchRequest.fullName = this.searchFullName5;
            this.getAllData();
        }
    }

    clearfilterGrid(tabNo: number, pageStatus: string) {

        if (tabNo === 0) {
            this.selectedAbsenceType1 = this.absenceTypeList[0];
            this.selectedDepartment1 = this.departmentList[0];
            this.startDateFilterValue1.setValue(null);
            this.endDateFilterValue1.setValue(null);
            this.searchFullName1 = null;
        } else if (tabNo === 1) {
            this.selectedAbsenceType2 = this.absenceTypeList[0];
            this.selectedDepartment2 = this.departmentList[0];
            this.startDateFilterValue2.setValue(null);
            this.endDateFilterValue2.setValue(null);
            this.searchFullName2 = null;
        } else if (tabNo === 2) {
            this.selectedAbsenceType3 = this.absenceTypeList[0];
            this.selectedDepartment3 = this.departmentList[0];
            this.startDateFilterValue3.setValue(null);
            this.endDateFilterValue3.setValue(null);
            this.searchFullName3 = null;
        } else if (tabNo === 3) {
            this.selectedAbsenceType4 = this.absenceTypeList[0];
            this.selectedDepartment4 = this.departmentList[0];
            this.startDateFilterValue4.setValue(null);
            this.endDateFilterValue4.setValue(null);
            this.searchFullName4 = null;
        } else if (tabNo === 4) {
            this.selectedAbsenceType5 = this.absenceTypeList[0];
            this.selectedDepartment5 = this.departmentList[0];
            this.startDateFilterValue5.setValue(null);
            this.endDateFilterValue5.setValue(null);
            this.searchFullName5 = null;
        }
        this.filterGrid(tabNo, pageStatus);
    }

    reportTab(tabNo: number, pageStatus: string) {

        // change datasource by using filters
        if (tabNo === 0) { // onay bekleyen
            let selectedDate = new Date(this.endDateFilterValue1.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue1.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue1.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;

            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType1.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment1.id;
            this.absenceSearchRequest.fullName = this.searchFullName1;

        } else if (tabNo === 1) { // izinlerim
            let selectedDate = new Date(this.endDateFilterValue2.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue2.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue2.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType2.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment2.id;
            this.absenceSearchRequest.fullName = this.searchFullName2;

        } else if (tabNo === 2) { // onayladiklarim
            //this.dsMyApprovals.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue3.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue3.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue3.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;

            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType3.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment3.id;
            this.absenceSearchRequest.fullName = this.searchFullName3;

        } else if (tabNo === 3) { // reddediklerim
            //this.dsRejects.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue4.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue4.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue4.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType4.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment4.id;
            this.absenceSearchRequest.fullName = this.searchFullName4;

        } else if (tabNo === 4) { // tum izinler
            //this.dsAll.data = this.filterData(pageStatus, tabNo);
            let selectedDate = new Date(this.endDateFilterValue5.value);
            selectedDate.setHours(23, 59, 59, 0);

            this.absenceSearchRequest.absenceStartDate = this.startDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(this.startDateFilterValue5.value, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceEndDate = this.endDateFilterValue5.value ? this.utilityService.converDateToStringWithFormat(selectedDate, AppConstants.MOMENT_DATETIME_FORMAT_2) : null;
            this.absenceSearchRequest.absenceTypeId = this.selectedAbsenceType5.id;
            this.absenceSearchRequest.departmentId = this.selectedDepartment5.id;
            this.absenceSearchRequest.status = this.selectedStatu5.id;
            this.absenceSearchRequest.fullName = this.searchFullName5;

        }
        const absenceReportRequest = new AbsenceReportRequest(this.absenceSearchRequest, pageStatus);

        this.absenceService.getReportData(absenceReportRequest).subscribe(reportResult => {
            const excelData = this.reportService.convertAbsenceReportResponseToSheetDataWithName(reportResult.responseData.item);
            this.reportService.exportAsExcelFile(excelData, reportResult.responseData.item.workBookName);
        });


    }

    getAllData() {
        this.absenceService.listAbsenceAll(this.absenceSearchRequest).subscribe(absences => {
            this.dsAll = new MatTableDataSource(absences.responseData.items)

            this.allPaginator.length = absences.totalCount;
            this.allPaginator.pageIndex = this.absenceSearchRequest.pageNumber;
            this.allPaginator.pageSize = this.absenceSearchRequest.size;
            this.allPaginator._intl = this.paginatorIntl;

            this.dsAll.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.absenceTypeName + ' ' + data.description)).includes(filter);

        });
    }

    getRejectData() {
        this.absenceService.listAbsenceRejecteds(this.absenceSearchRequest).subscribe(absences => {
            this.dsRejects = new MatTableDataSource(absences.responseData.items);

            this.rejectsPaginator.length = absences.totalCount;
            this.rejectsPaginator.pageIndex = this.absenceSearchRequest.pageNumber;
            this.rejectsPaginator.pageSize = this.absenceSearchRequest.size;
            this.rejectsPaginator._intl = this.paginatorIntl;

            this.dsRejects.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.absenceTypeName + ' ' + data.description)).includes(filter);

        });
    }

    getApprovalData() {
        this.absenceService.listAbsenceMyApproveds(this.absenceSearchRequest).subscribe(absences => {
            this.dsMyApprovals = new MatTableDataSource(absences.responseData.items);

            this.myApprovalsPaginator.length = absences.totalCount;
            this.myApprovalsPaginator.pageIndex = this.absenceSearchRequest.pageNumber;
            this.myApprovalsPaginator.pageSize = this.absenceSearchRequest.size;
            this.myApprovalsPaginator._intl = this.paginatorIntl;

            this.dsMyApprovals.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.absenceTypeName + ' ' + data.description)).includes(filter);

        });
    }

    getMyRequestData() {
        this.absenceService.listAbsenceMyRequest(this.absenceSearchRequest).subscribe(absences => {
            this.dsMyRequest = new MatTableDataSource(absences.responseData.items);

            this.myRequestPaginator.length = absences.totalCount;
            this.myRequestPaginator.pageIndex = this.absenceSearchRequest.pageNumber;
            this.myRequestPaginator.pageSize = this.absenceSearchRequest.size;
            this.myRequestPaginator._intl = this.paginatorIntl;

            this.dsMyRequest.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.absenceTypeName + ' ' + data.description)).includes(filter);

        });
    }

    getWaitingData() {
        this.absenceService.listAbsenceWaitings(this.absenceSearchRequest).subscribe(absences => {
            this.dsWaitings = new MatTableDataSource(absences.responseData.items);

            this.waitingsPaginator.length = absences.totalCount;
            this.waitingsPaginator.pageIndex = this.absenceSearchRequest.pageNumber;
            this.waitingsPaginator.pageSize = this.absenceSearchRequest.size;
            this.waitingsPaginator._intl = this.paginatorIntl;

            this.dsWaitings.filterPredicate =
                (data: any, filter: string) => !filter || this.utilityService.toTurkishLowerCase(
                    JSON.stringify(data.name + ' ' + data.surname + ' ' + data.departmentName + ' ' + data.absenceTypeName + ' ' + data.description)).includes(filter);

        });
    }
}
